import { Button, Card, Typography } from "antd";
import styled from "styled-components";
export const getLighterColor = (secondaryColor, opacity) => {
    if (secondaryColor.startsWith("#")) {
        return hexToRGBA(secondaryColor, opacity || 0.2);
    }
    else if (secondaryColor.startsWith("rgb") ||
        secondaryColor.startsWith("rgba")) {
        return secondaryColor.replace(/\d?\.?\d+$/, "0.05");
    }
    return secondaryColor;
};
export function hexToRGBA(hex, alpha) {
    const [r, g, b] = hex.match(/\w\w/g).map((x) => parseInt(x, 16));
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
const { Title } = Typography;
export const CandidateHeaderCard = styled(Card) `
  margin-bottom: 10px;
  background: white;
  border-radius: 12px;
  border: 1px solid #181d27;
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.16);
  margin-top: 10px;

  .ant-card-body {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 28px 12px 16px;

    @media (max-width: 768px) {
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
    }
  }

  .ant-select-dropdown {
    z-index: 1200 !important;
  }
`;
export const CandidateHeaderLeft = styled.div `
  display: flex;
  align-items: center;
  gap: ${({ $hasAvatar }) => ($hasAvatar ? "10px" : "0")};
  flex: 1;
  min-width: 0;
`;
export const ProfileImage = styled.img `
  width: 71px;
  height: 80px;
  border-radius: 4px;
  flex-shrink: 0;
  display: block;
  object-fit: cover;
  object-position: center center;
  background: lightgray;
`;
export const HeaderContent = styled.div `
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
  min-width: 0;
`;
export const DescriptionRow = styled.div `
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;
export const Description = styled.div `
  font-size: 14px;
  font-weight: 400;
  color: #252733;
`;
export const CandidateName = styled(Title) `
  margin: 0 !important;
  font-size: 24px !important;
  font-weight: 600;
  color: ${(props) => { var _a, _b; return ((_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.colorPalette) === null || _b === void 0 ? void 0 : _b.secondaryColor) || "#4BC6B9"; }} !important;
`;
export const DetailsRow = styled.div `
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
`;
export const DesktopScoreWrapper = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;

  @media (max-width: 768px) {
    display: none;
  }
`;
export const MobileScoreCard = styled.div `
  display: none;

  @media (max-width: 768px) {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-top: 4px;
    border-radius: 4px;
    border: 1px solid #181d27;
    background: #fff;
    box-shadow: 0 1px 2px 0 rgba(10, 13, 18, 0.05);
    padding: 16px 32px;
    margin-bottom: 22px;
  }
`;
export const ScoreValue = styled.span `
  color: ${(props) => props.color || "#181d27"};
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.72px;
  margin-right: 4px;

  @media (max-width: 768px) {
    font-size: 18px;
    text-align: center;
  }
`;
export const ScoreLabel = styled.span `
  color: #252733;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.42px;
`;
export const ViewResumeButton = styled(Button) `
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  padding: 2px 12px;
  border-radius: 4px;
  background: #f8f8f8;
  border: none;
  color: #181d27;
  font-weight: 500;

  &:hover,
  &:focus {
    background: #f0f0f0;
    color: #181d27;
  }
`;
